<!--
  El detalle de UN tipo de solicitud. Pantalla propia, ruta propia, ancho completo — sin modal y
  sin acordeón: regla de la casa.

  Sin dibujo, y es una decisión: un tipo tiene uno o dos pasos. La comparación entre tipos —lo
  único que un dibujo cuenta mejor que una lista— está en la portada. Aquí va lo que un dibujo no
  puede decir: qué es cada paso, quién lo decide, y qué comercio se aparta.
-->
<div class="kb-page">

  <a class="tf-volver" routerLink="/console/tipos-flujos">
    <i class="fas fa-arrow-left" aria-hidden="true"></i>Tipos y pasos del cliente
  </a>

  <!-- ══ Cargando ══════════════════════════════════════════════════════════════════════════════ -->
  <div class="space-y-6" *ngIf="cargando" aria-hidden="true">
    <div class="kb-skeleton h-12 w-2/3"></div>
    <div class="kb-skeleton h-40 w-full"></div>
  </div>
  <p class="sr-only" *ngIf="cargando">Cargando el tipo de solicitud.</p>

  <!-- ══ Error ═════════════════════════════════════════════════════════════════════════════════ -->
  <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && error">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">No se pudo traer el catálogo</p>
      <p>{{ error }}</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargar()">
        <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar el tipo
      </button>
    </div>
  </div>

  <!-- ══ El código no existe ═══════════════════════════════════════════════════════════════════
       Dos vacíos distintos son dos frases distintas: «el catálogo no se pudo traer» no es lo mismo
       que «el catálogo se trajo y este código no está». -->
  <div class="kb-tarjeta" *ngIf="!cargando && !error && !tipo">
    <div class="kb-empty">
      <div class="kb-empty-icono"><i class="fas fa-question-circle" aria-hidden="true"></i></div>
      <p class="kb-empty-titulo">No hay ningún tipo de solicitud con el código «{{ code }}»</p>
      <p class="kb-empty-texto">
        Los tipos nacen en el código del canal POS: si este no está en el catálogo, no existe.
      </p>
      <a class="kb-btn kb-btn-outline kb-btn-sm" routerLink="/console/tipos-flujos">Ver los tipos de solicitud</a>
    </div>
  </div>

  <ng-container *ngIf="!cargando && !error && tipo">

    <!-- ══ Portada ═════════════════════════════════════════════════════════════════════════════ -->
    <div class="kb-page-header">
      <div>
        <h1 class="kb-page-title">{{ tipo.nombre }}</h1>
        <p class="kb-page-meta">
          {{ tipo.origen }}.
          <ng-container *ngIf="recorrido.length; else sinPasos">
            El cliente hace {{ recorrido.length }} {{ recorrido.length === 1 ? 'paso' : 'pasos' }},
            y el último es «{{ nombrePaso(tipo.termina_en || '') }}».
          </ng-container>
          <ng-template #sinPasos>Hoy este tipo no le pide ningún paso al cliente.</ng-template>
        </p>
      </div>
      <div class="tf-marcas">
        <span class="kb-badge kb-badge-marca" *ngIf="tipo.por_omision">por omisión</span>
        <span class="kb-badge kb-badge-contorno tf-codigo">{{ tipo.code }}</span>
      </div>
    </div>

    <p class="tf-contexto" *ngIf="comercioCodigo">
      <i class="fas fa-store" aria-hidden="true"></i>
      Mostrando el recorrido de <strong>{{ nombreComercio }}</strong>.
    </p>

    <!-- ══ Los pasos, uno por uno ══════════════════════════════════════════════════════════════ -->
    <section class="kb-tarjeta" *ngIf="recorrido.length">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Los pasos, uno por uno</h2>
        <p class="text-sm text-muted-foreground">
          Qué le pide cada paso al cliente, quién lo decide y qué comercio se aparta.
        </p>
      </div>

      <div class="kb-tarjeta-cuerpo">
      <ol class="tf-pasos">
        <li class="tf-paso" *ngFor="let n of recorrido">
          <div class="tf-paso-numero" [ngClass]="claseDecide(n.decide)" aria-hidden="true">{{ n.orden }}</div>
          <div class="tf-paso-cuerpo">
            <div class="tf-paso-cabeza">
              <h3 class="tf-paso-titulo">{{ n.nombre }}</h3>
              <span class="tf-etiqueta" *ngIf="n.requerido !== null">
                {{ n.requerido ? 'Obligatorio' : 'Opcional' }}
              </span>
              <span class="kb-badge" [ngClass]="claseDecide(n.decide)">
                <i class="fas" [ngClass]="iconoDecide(n.decide)" aria-hidden="true"></i>
                Lo pone {{ textoDecide(n.decide) }}
              </span>
              <span class="kb-badge kb-badge-contorno" *ngIf="esElUltimo(n.code)">cierra la solicitud</span>
              <span class="kb-badge kb-badge-contorno" *ngIf="esElQueDistingue(n.code)">sólo lo trae este tipo</span>
            </div>

            <p class="tf-paso-texto">{{ n.descripcion }}</p>
            <p class="tf-paso-texto tf-paso-sentido">{{ sentidoDecide(n.decide) }}</p>

            <p class="tf-paso-config" *ngIf="configDe(n.code).length">
              <span class="tf-etiqueta">Configuración del flujo por omisión</span>
              <span class="tf-config-par" *ngFor="let c of configDe(n.code)">
                {{ c.clave }}: <strong>{{ c.valor }}</strong>
              </span>
            </p>

            <div class="tf-apartan" *ngIf="apartanEn(n.code).length">
              <span class="tf-etiqueta tf-etiqueta-alerta">
                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                Comercios que se apartan aquí
              </span>
              <ul class="tf-apartan-lista">
                <li *ngFor="let m of apartanEn(n.code)">
                  <strong>{{ m.nombre }}</strong>
                  {{ m.lo_pide ? 'lo pide y el recorrido por omisión no' : 'no lo pide y el recorrido por omisión sí' }}
                  <span class="tf-apartan-version">{{ m.version }}</span>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ol>
      </div>
    </section>

    <!-- ══ Los pasos que este tipo no trae ═════════════════════════════════════════════════════
         No es relleno: un paso que existe en el catálogo y que este recorrido no trae es justo lo
         que hay que mirar cuando alguien pregunta por qué un cliente no vio algo. -->
    <section class="kb-tarjeta" *ngIf="fuera.length">
      <div class="kb-tarjeta-cab">
        <h2 class="text-base font-semibold leading-none">Pasos que este tipo no trae</h2>
        <p class="text-sm text-muted-foreground">
          Existen en el catálogo y este recorrido no los pide. Es lo que hay que mirar
          cuando alguien pregunta por qué un cliente no vio algo.
        </p>
      </div>

      <div class="kb-tarjeta-cuerpo">
      <ul class="tf-fuera">
        <li class="tf-fuera-item" *ngFor="let p of fuera">
          <div class="tf-fuera-cabeza">
            <span class="tf-fuera-titulo">{{ nombrePaso(p.code) }}</span>
            <span class="kb-badge kb-badge-contorno">
              <i class="fas" [ngClass]="iconoDecide(p.decide)" aria-hidden="true"></i>
              Lo pondría {{ textoDecide(p.decide) }}
            </span>
          </div>
          <p class="tf-paso-texto">{{ p.descripcion }}</p>

          <div class="tf-apartan" *ngIf="apartanEn(p.code).length">
            <span class="tf-etiqueta tf-etiqueta-alerta">
              <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
              Comercios que sí lo piden
            </span>
            <ul class="tf-apartan-lista">
              <li *ngFor="let m of apartanEn(p.code)">
                <strong>{{ m.nombre }}</strong>
                <span class="tf-apartan-version">{{ m.version }}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      </div>
    </section>

    <!-- ══ Las líneas del pie ══════════════════════════════════════════════════════════════════ -->
    <div class="tf-notas">
      <p *ngIf="lineaComercio">{{ lineaComercio }}</p>
      <p class="tf-vigencia-linea">
        <i class="fas fa-history" aria-hidden="true"></i>
        <span>Así está configurado <strong>hoy, {{ hoy }}</strong>.</span>
        <button type="button" class="tf-vigencia-boton"
                [attr.aria-expanded]="vigenciaAbierta"
                (click)="vigenciaAbierta = !vigenciaAbierta">
          Por qué importa
          <i class="fas" [ngClass]="vigenciaAbierta ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
        </button>
      </p>
      <p class="tf-vigencia-texto" *ngIf="vigenciaAbierta">
        Cada flujo tiene su versión y su fecha de vigencia, y cada solicitud guarda la fotografía
        del flujo que le tocó el día en que se creó (<code class="kb-td-mono">flow_snapshot</code>).
        Si estás explicando una solicitud <strong>vieja</strong>, pudo haber seguido otro recorrido
        — no necesariamente el que ves aquí.
      </p>
    </div>

  </ng-container>
</div>
